import type { SgWorkspace } from "./api/types.ts";

export const SG_WORKSPACE_CHANGED_EVENT = "SgWorkspaceChanged" as const;

declare module "@sg-protect/federation-runtime" {
    interface EventMap {
        [SG_WORKSPACE_CHANGED_EVENT]: { workspace: SgWorkspace };
    }
}
